import React from 'react'
// libs
import styled from 'styled-components'
import { reduxForm } from 'redux-form'
// components
import { ReduxInput } from 'components/FormElements/ReduxForm'
import { DialogContent, Grid2 as Grid } from '@mui/material'
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// themes
import { colors } from 'themes/index'
import { ActionsWrapper } from 'themes/views/modals'
// constants
import { Forms } from 'constants/forms'
// types
import { InjectedFormProps } from 'redux-form/lib/reduxForm'

const InputWrapper = styled(DialogContent)`
  && {
    color: ${colors.gray900};
    padding: 24px;
    height: 350px;
    overflow: auto;
  }
`

interface Props {
  licenceType: string
  onCancelClick: () => void
}

const SetDocumentDescriptionForm: React.FC<InjectedFormProps<any, Props> & Props> = ({
  licenceType,
  handleSubmit,
  onCancelClick
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <InputWrapper>
        <ReduxInput multiline name='description' label={licenceType} />
      </InputWrapper>
      <ActionsWrapper>
        <Grid container spacing={2}>
          <Grid>
            <Button layout={BUTTON_LAYOUTS.PURPLE} type='submit'>
              Save
            </Button>
          </Grid>
          <Grid>
            <Button layout={BUTTON_LAYOUTS.WHITE} onClick={onCancelClick}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </ActionsWrapper>
    </form>
  )
}

export default reduxForm<any, Props>({
  form: Forms.SET_DOCUMENT_DESCRIPTION_FORM,
  enableReinitialize: true
})(SetDocumentDescriptionForm)
